import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";

interface ActionButtonProps {
  icon: React.ReactNode;
  tooltip: string;
  onClick: () => void;
  disabled?: boolean;
}

interface RowActionButtonsProps {
  actions: ActionButtonProps[];
}

export const RowActionButtons: React.FC<RowActionButtonsProps> = ({ actions }) => {
  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      {actions.map((action, index) => (
        <Tooltip key={index} title={action.tooltip} arrow>
          <span>
            <IconButton
              size="small"
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.icon}
            </IconButton>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};